<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Bank Accounts</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><router-link :to="{name:'dashboards'}">Dashboard</router-link></li>
              <li class="breadcrumb-item active">Bank Accounts</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <button class="btn btn-primary mb-3" @click="showForm = true; form = {}">+ Tambah Rekening</button>

            <div v-if="showForm" class="card bg-light p-3 mb-3">
              <h6>{{ form.tpa_id ? 'Edit' : 'Tambah' }} Rekening</h6>
              <div class="form-row">
                <div class="form-group col-md-4">
                  <label>Nama Bank</label>
                  <input class="form-control" v-model="form.bank_name" placeholder="BCA" />
                </div>
                <div class="form-group col-md-4">
                  <label>No Rekening</label>
                  <input class="form-control" v-model="form.account_number" placeholder="1234567890" />
                </div>
                <div class="form-group col-md-4">
                  <label>Atas Nama</label>
                  <input class="form-control" v-model="form.account_name" placeholder="PT Mentari Motor" />
                </div>
              </div>
              <div class="form-group">
                <label class="d-flex align-items-center">
                  <input type="checkbox" v-model="form.is_active" :true-value="1" :false-value="0" />
                  <span class="ml-2">Aktif</span>
                </label>
              </div>
              <div>
                <button class="btn btn-success mr-1" @click="saveAccount">Simpan</button>
                <button class="btn btn-secondary" @click="showForm = false">Batal</button>
              </div>
            </div>

            <table class="table">
              <thead>
                <tr><th>Bank</th><th>No Rekening</th><th>Atas Nama</th><th>Status</th><th>Aksi</th></tr>
              </thead>
              <tbody>
                <tr v-for="acc in accounts" :key="acc.tpa_id">
                  <td>{{ acc.bank_name }}</td>
                  <td>{{ acc.account_number }}</td>
                  <td>{{ acc.account_name }}</td>
                  <td><span :class="acc.is_active ? 'badge badge-success' : 'badge badge-secondary'">{{ acc.is_active ? 'Aktif' : 'Nonaktif' }}</span></td>
                  <td>
                    <button class="btn btn-sm btn-info" @click="editAccount(acc)">Edit</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accounts: [],
      showForm: false,
      form: { bank_name: '', account_number: '', account_name: '', is_active: 1 },
    };
  },
  mounted() { this.loadAccounts(); },
  methods: {
    loadAccounts() {
      this.axios.get('/product-purchase/admin/bank-accounts')
        .then(r => { if (r.data.status === 200) this.accounts = r.data.data; });
    },
    saveAccount() {
      this.axios.post('/product-purchase/admin/bank-accounts', this.form)
        .then(r => {
          if (r.data.status === 200) {
            this.$swal.fire('Berhasil', r.data.message, 'success');
            this.showForm = false;
            this.loadAccounts();
          }
        });
    },
    editAccount(acc) {
      this.form = { ...acc };
      this.showForm = true;
    },
  }
};
</script>
